<button
  type="button"
  class="btn p-1 lh-1 border-0"
  [disabled]="agentStatus.isStatusChangeInProgress()"
  [pTooltip]="'AgentDesktop::AgentStatus:QuickAvailable' | abpLocalization"
  tooltipPosition="left"
  (click)="onQuickAvailable()">
  <i class="fas fa-check-circle lpx-menu-item-icon quick-available-icon"></i>
</button>
